module.exports = "/_next/static/images/calendar-mini-purple-e599a7a889079be68db8e493b4f2fd03.svg";